import React from "react";

function SolutionFirst() {
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="w-full md:w-11/12 py-10 px-2 md:px-10 gap-x-10 flex justify-center items-center bg-black bg-opacity-20 rounded-lg">
        <div className="w-1/2 md:w-3/5 flex flex-col px-2 md:px-10 gap-y-5">
          <h1 className="text-2xl md:text-6xl">
            IT Solutions that accelarate your Business
          </h1>
          <p className="hidden md:block w-2/3 md:text-xl text-slate-300">
            We translate your business needs into actual solutions by offering
            professional and custom software services. Your technological
            journey starts here.
          </p>
          <div className="w-2/3 flex justify-evenly md:text-xl gap-x-2">
            <button className="bg-white bg-opacity-20 rounded-lg p-1 md:px-5 md:py-3 shadow-xl border border-slate-100">
              View Our Team
            </button>
            <button className="bg-black bg-opacity-20 rounded-lg p-1 md:px-5 md:py-3 shadow-xl border border-slate-100">
              Get In Touch
            </button>
          </div>
        </div>
        <div className="relative w-1/2 md:w-2/5 flex justify-center items-center">
          <div className="w-4/5 h-72 bg-white bg-opacity-50 rounded-lg"></div>
          <img
            src="serviceImg/uiUx.png"
            alt="serviceImage"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}

export default SolutionFirst;
